<template>
    <div class="main-wrapper scroll-y custom-scrollbar with-tabs view-user-profile-token" style="background: #fff">

        <page-title :title="'Potwierdzenie'" :back="true"></page-title>

        <slide-y-up-transition :duration="500" :delay="200">
            <div v-show="show" class="box-info text-center">
                Przepisz kod, który wysłaliśmy SMSem na Twój numer telefonu.
            </div>
        </slide-y-up-transition>

        <form class="form form-user-phone-token" @submit.prevent="postToken">
            <slide-x-left-transition :duration="400" :delay="200">
                <div class="form-group" v-show="show">
                    <label>Kod SMS</label>
                    <div class="input-wrapper">
                        <input v-model="form.sms_token"
                               type="number"
                               :class="{'input-error' : errors.sms_token }"
                               placeholder="Podaj kod SMS"
                               ref="smsTokenInput"
                               required/>
                    </div>
                    <p class="error" v-if="errors.sms_token">{{ errors.sms_token[0] }}</p>
                </div>
            </slide-x-left-transition>
            <ion-button mode="ios" expand="block" type="submit" :disabled="loading">
                <span v-if="loading"><span class="loader"></span></span>
                <span v-else>Dalej</span>
            </ion-button>
        </form>

    </div>
</template>

<script>
  import { mapState } from 'vuex';
    import PageTitle from '@/components/PageTitle.vue';
    import goTo from '@/mixins/goto';

    export default {
        name: 'UserProfileToken',
        components: { PageTitle },
        mixins: [goTo],
        data() {
            return {
                show: false,
                form: {
                    sms_token: '',
                }
            }
        },
        computed: {
          ...mapState({
            loading: state => state.profile.loading,
            errors: state => state.profile.errors,
            new_phone_number: state => state.profile.new_phone_number,
            hash: state => state.profile.hash
          })
        },
        mounted() {
            this.show = true;
            setTimeout(() => {
                this.$refs.smsTokenInput.focus();
            }, 1000)
        },
        methods: {
            postToken() {
                let data = {
                    'phone_number': this.new_phone_number,
                    'sms_token': this.form.sms_token,
                    'hash': this.hash
                }
                this.$store.dispatch('profile/UPDATE_PROFILE_TOKEN_REQUEST', data).then(() => {
                    this.goTo('UserProfileIndex')
                })
            }
        }
    }
</script>